/*
  Auto-generated by Spline
*/

import useSpline from '@splinetool/r3f-spline'
import { OrthographicCamera } from '@react-three/drei'
import { useEffect, useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { Vector3, MathUtils } from 'three';

export default function Scene({ fileUploaded, onAnimationComplete, ...props }) {
  const { nodes, materials } = useSpline('https://prod.spline.design/ziEFn4pDFhxE5Ldi/scene.splinecode')

  const blueHead = useRef();
  const orangeHead = useRef();
  const leftLight = useRef();
  const cameraRef = useRef();
  const leftCurtainRef = useRef();
  const rightCurtainRef = useRef();

  const [targetZoom, setTargetZoom] = useState(null);
  const [targetPosition, setTargetPosition] = useState(null);
  const [curtainsMoved, setCurtainsMoved] = useState(false);

  const [animationProgress, setAnimationProgress] = useState(0);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [curtainStartPosition, setCurtainStartPosition] = useState({ left: 0, right: 0 });
  const [cameraStartPosition, setCameraStartPosition] = useState(null);
  const [cameraTargetPosition, setCameraTargetPosition] = useState(null);

  useEffect(() => {
    if (fileUploaded) {
    const currentPosition = cameraRef.current.position;
      const newPosition = new Vector3(
        currentPosition.x + 1085, // Move right by decreasing x
        currentPosition.y,
        currentPosition.z
      );
      setTargetPosition(newPosition);

      setCurtainStartPosition({
          left: leftCurtainRef.current.position.x,
          right: rightCurtainRef.current.position.x
      });

      setCameraStartPosition(currentPosition.clone());
      setCameraTargetPosition(new Vector3(currentPosition.x, currentPosition.y + 100, currentPosition.z)); // Move camera up by 40 units
    }
  }, [fileUploaded]);

  useFrame(() => {
    const camera = cameraRef.current;
    if (camera && targetPosition) {
      // Smooth transition to new position
      camera.position.lerp(targetPosition, 0.02); // Modify 0.02 to adjust the speed of the movement
      if (camera.position.distanceTo(targetPosition) < 0.1) {
        camera.position.copy(targetPosition);
        setTargetPosition(null);
        if (animationProgress === 0) setAnimationProgress(0.01);
      }
    }
  });

    useFrame(() => {
        if (animationProgress > 0 && animationProgress < 1) {
        const easeInOutSine = t => -(Math.cos(Math.PI * t) - 1) / 2;
        const progress = easeInOutSine(animationProgress);
        leftCurtainRef.current.position.x = MathUtils.lerp(curtainStartPosition.left, curtainStartPosition.left - 1000, progress);
        rightCurtainRef.current.position.x = MathUtils.lerp(curtainStartPosition.right, curtainStartPosition.right + 1000, progress);
        cameraRef.current.position.y = MathUtils.lerp(cameraStartPosition.y, cameraTargetPosition.y, progress);
        setAnimationProgress(animationProgress + 0.01); // Update progress
        setAnimationComplete(true);
        if (animationProgress >= 1) {
            setAnimationProgress(1);

            //
            console.log(animationComplete, " IS ANIMATION COMPLETE");
            setAnimationComplete(true);

            if (!animationComplete) {
                setAnimationComplete(true);
                onAnimationComplete();
            }
        }
    }
  });

  useFrame(({ clock }) => {
    if (blueHead.current) {
      const time = clock.getElapsedTime();
      const rotationAmplitude = 2.1;
      blueHead.current.rotation.x = 0 + (rotationAmplitude * Math.sin(time * 2.2) * (Math.PI / 180));
    }
  });

  useFrame(({ clock }) => {
    if (orangeHead.current) {
      const time = clock.getElapsedTime() ;
      const rotationAmplitude = 2.3;
      orangeHead.current.rotation.x = 0 + (rotationAmplitude * Math.sin((time - 0.4) * 2.2) * (Math.PI / 180));
    }
  });

  useFrame(({ clock }) => {
    if (leftLight.current) {
      const time = clock.getElapsedTime();
      const rotationAmplitude = 8;
      leftLight.current.rotation.x = 0 + (rotationAmplitude * Math.sin(time * 1.2) * (Math.PI / 180));
    }
  });

  return (
    <>
      <color attach="background" args={['#f0f2f7']} />
      <group {...props} dispose={null}>
        <scene name="Scene 1">
          <mesh
            name="VR (no text).png"
            geometry={nodes['VR (no text).png'].geometry}
            material={materials['VR (no text).png Material']}
            castShadow
            receiveShadow
            position={[1041.04, 84.84, -625.83]}
            scale={[1.11, 1, 1]}
          />
          <group name="OrangeDude 3" position={[315.04, -206.45, -319.97]} scale={1.22}>
            <group name="Orange Head" position={[0.1, 138.01, -18.9]} ref={orangeHead}>
              <group name="Wizard Hat" position={[0.05, 30.38, -1.8]} rotation={[-0.14, 0, 0]} scale={1.37}>
                <mesh
                  name="Torus"
                  geometry={nodes.Torus.geometry}
                  material={materials['Torus Material']}
                  castShadow
                  receiveShadow
                  position={[0.25, -12.17, 0.08]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={[1.37, 1.68, 1]}
                />
                <mesh
                  name="Merged Geometry"
                  geometry={nodes['Merged Geometry'].geometry}
                  material={materials.Wizard}
                  castShadow
                  receiveShadow
                  position={[0, 0.02, 0]}
                />
              </group>
              <group name="Right freckles" position={[37.91, -47.88, 58.8]} rotation={[0, 0, Math.PI / 2]} scale={1}>
                <mesh
                  name="Ellipse 3"
                  geometry={nodes['Ellipse 3'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[2.27, -1.11, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse 2"
                  geometry={nodes['Ellipse 2'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-2.27, -2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse"
                  geometry={nodes.Ellipse.geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-1.86, 2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
              </group>
              <group name="Left freckles" position={[-40.07, -47.88, 58.8]}>
                <mesh
                  name="Ellipse 31"
                  geometry={nodes['Ellipse 31'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[2.27, -1.11, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse 21"
                  geometry={nodes['Ellipse 21'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-2.27, -2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse1"
                  geometry={nodes.Ellipse1.geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-1.86, 2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
              </group>
              <group name="Face" position={[-0.45, -42.94, 73.64]}>
                <mesh
                  name="Sphere 2"
                  geometry={nodes['Sphere 2'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[15.18, 14.79, -10.1]}
                />
                <mesh
                  name="Sphere 3"
                  geometry={nodes['Sphere 3'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-14.59, 14.79, -10.1]}
                />
                <mesh
                  name="Path 2"
                  geometry={nodes['Path 2'].geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[0, -0.26, 0.12]}
                  rotation={[-Math.PI, 0, -Math.PI]}
                />
                <mesh
                  name="Path"
                  geometry={nodes.Path.geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[0, -0.26, 0.12]}
                />
                <mesh
                  name="Cube"
                  geometry={nodes.Cube.geometry}
                  material={materials.OrangeDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-0.36, 2.98, 0]}
                  scale={[1.59, 0.87, 1]}
                />
              </group>
              <mesh
                name="Head"
                geometry={nodes.Head.geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[-0.92, -37.45, 14.33]}
              />
            </group>
            <group name="Left Arm" position={[-45.33, 30.69, 13.31]}>
              <mesh
                name="Cloak Left Arm"
                geometry={nodes['Cloak Left Arm'].geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[-4.47, -20.98, 2.58]}
                rotation={[0, Math.PI / 6, 0]}
                scale={1}
              />
              <mesh
                name="Left Arm1"
                geometry={nodes['Left Arm1'].geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[-3.52, -15.19, 2.03]}
                rotation={[0, Math.PI / 6, 0]}
                scale={1}
              />
            </group>
            <group name="Right Arm" position={[48.64, 30.02, 13.32]}>
              <mesh
                name="Cloak Right Arm"
                geometry={nodes['Cloak Right Arm'].geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[4.26, -19.21, 2.46]}
                rotation={[-Math.PI, Math.PI / 6, -Math.PI]}
                scale={1}
              />
              <mesh
                name="Right Arm1"
                geometry={nodes['Right Arm1'].geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[3.5, -14.52, 2.02]}
                rotation={[-Math.PI, Math.PI / 6, -Math.PI]}
                scale={1}
              />
            </group>
            <group name="Body" position={[0, 24.53, -10.98]}>
              <mesh
                name="Right leg"
                geometry={nodes['Right leg'].geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[24.73, -71.24, -2.78]}
                rotation={[0, 0, 0.17]}
                scale={1}
              />
              <mesh
                name="Left Leg"
                geometry={nodes['Left Leg'].geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[-23.95, -69.78, -1.59]}
                rotation={[0, 0, -0.17]}
                scale={1}
              />
              <mesh
                name="Cloak"
                geometry={nodes.Cloak.geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[0, -14.49, 0]}
                scale={[1.68, 1.93, 1.34]}
              />
              <mesh
                name="Body1"
                geometry={nodes.Body1.geometry}
                material={materials.OrangeDude}
                castShadow
                receiveShadow
                position={[0, -13.81, 0]}
                scale={[1.68, 1.93, 1.34]}
              />
            </group>
          </group>
          <group name="BlueDude" position={[118.84, -206.45, -319.97]} scale={1.22}>
            <group name="BlueHead" position={[0.12, 157.2, -20.56]} ref={blueHead}>
              <mesh
                name="Head1"
                geometry={nodes.Head1.geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[-0.94, -56.64, 15.98]}
              />
              <group name="Wizard Hat1" position={[0.03, 10.55, -0.05]} rotation={[3.01, 0.75, Math.PI]} scale={1.37}>
                <mesh
                  name="Torus1"
                  geometry={nodes.Torus1.geometry}
                  material={materials['Torus1 Material']}
                  castShadow
                  receiveShadow
                  position={[0.25, -12.17, 0.08]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={[1.37, 1.68, 1]}
                />
                <mesh
                  name="Merged Geometry1"
                  geometry={nodes['Merged Geometry1'].geometry}
                  material={materials.Wizard}
                  castShadow
                  receiveShadow
                  position={[0, 0.02, 0]}
                />
              </group>
              <group name="Right freckles1" position={[37.89, -67.07, 60.46]} rotation={[0, 0, Math.PI / 2]} scale={1}>
                <mesh
                  name="Ellipse 32"
                  geometry={nodes['Ellipse 32'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[2.27, -1.11, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse 22"
                  geometry={nodes['Ellipse 22'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-2.27, -2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse2"
                  geometry={nodes.Ellipse2.geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-1.86, 2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
              </group>
              <group name="Left freckles1" position={[-40.09, -67.07, 60.46]}>
                <mesh
                  name="Ellipse 33"
                  geometry={nodes['Ellipse 33'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[2.27, -1.11, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse 23"
                  geometry={nodes['Ellipse 23'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-2.27, -2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
                <mesh
                  name="Ellipse3"
                  geometry={nodes.Ellipse3.geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-1.86, 2.35, 0]}
                  rotation={[0, 0, 0.75]}
                />
              </group>
              <group name="Face1" position={[-0.48, -62.13, 75.3]}>
                <mesh
                  name="Sphere 21"
                  geometry={nodes['Sphere 21'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[15.18, 14.79, -10.1]}
                />
                <mesh
                  name="Sphere 31"
                  geometry={nodes['Sphere 31'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-14.59, 14.79, -10.1]}
                />
                <mesh
                  name="Path 21"
                  geometry={nodes['Path 21'].geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[0, -0.26, 0.12]}
                  rotation={[-Math.PI, 0, -Math.PI]}
                />
                <mesh
                  name="Path1"
                  geometry={nodes.Path1.geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[0, -0.26, 0.12]}
                />
                <mesh
                  name="Cube1"
                  geometry={nodes.Cube1.geometry}
                  material={materials.BlueDudeEyes}
                  castShadow
                  receiveShadow
                  position={[-0.36, 2.98, 0]}
                  scale={[1.59, 0.87, 1]}
                />
              </group>
            </group>
            <group name="Body2" position={[0.1, 9.77, -10.98]}>
              <mesh
                name="Cloak1"
                geometry={nodes.Cloak1.geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[-0.1, 0.27, 0]}
                scale={[1.68, 1.93, 1.34]}
              />
              <mesh
                name="Right leg1"
                geometry={nodes['Right leg1'].geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[24.63, -56.49, -2.78]}
                rotation={[0, 0, 0.17]}
                scale={1}
              />
              <mesh
                name="Left Leg1"
                geometry={nodes['Left Leg1'].geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[-24.05, -55.02, -1.59]}
                rotation={[0, 0, -0.17]}
                scale={1}
              />
              <mesh
                name="Body3"
                geometry={nodes.Body3.geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[-0.1, 0.95, 0]}
                scale={[1.68, 1.93, 1.34]}
              />
            </group>
            <group name="Left Arm2" position={[-45.33, 30.69, 13.31]}>
              <mesh
                name="Cloak Left Arm1"
                geometry={nodes['Cloak Left Arm1'].geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[-4.47, -20.98, 2.58]}
                rotation={[0, Math.PI / 6, 0]}
                scale={1}
              />
              <mesh
                name="Left Arm3"
                geometry={nodes['Left Arm3'].geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[-3.52, -15.19, 2.03]}
                rotation={[0, Math.PI / 6, 0]}
                scale={1}
              />
            </group>
            <group name="Right Arm2" position={[48.64, 30.02, 13.32]}>
              <mesh
                name="Cloak Right Arm1"
                geometry={nodes['Cloak Right Arm1'].geometry}
                material={materials.Wizard}
                castShadow
                receiveShadow
                position={[4.26, -19.21, 2.46]}
                rotation={[-Math.PI, Math.PI / 6, -Math.PI]}
                scale={1}
              />
              <mesh
                name="Right Arm3"
                geometry={nodes['Right Arm3'].geometry}
                material={materials.BlueDude}
                castShadow
                receiveShadow
                position={[3.5, -14.52, 2.02]}
                rotation={[-Math.PI, Math.PI / 6, -Math.PI]}
                scale={1}
              />
            </group>
          </group>
          <mesh
            name="Cube 3"
            geometry={nodes['Cube 3'].geometry}
            material={materials['Cube 3 Material']}
            castShadow
            receiveShadow
            position={[1019.86, -430.32, -839.82]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <group name="Group 5" position={[2063.05, 249.95, -177.07]}>
            <spotLight
              name="Spot Light 2"
              castShadow
              intensity={1.23}
              angle={Math.PI / 5}
              distance={2000}
              shadow-mapSize-width={1024}
              shadow-mapSize-height={1024}
              shadow-camera-fov={119.99999999999999}
              shadow-camera-near={100}
              shadow-camera-far={100000}
              color="#fcfcc3"
              position={[-6.39, -88.14, -40.48]}
              rotation={[0, 0, -0.62]}
            />
            <group name="Light 2" position={[21.43, -81.14, -21.02]} rotation={[0.43, -0.68, 0.3]} scale={0.69}>
              <group name="body" position={[0.22, -22.71, 39.92]} rotation={[0.14, 0, 0]}>
                <mesh
                  name="Cube 2"
                  geometry={nodes['Cube 2'].geometry}
                  material={materials['Cube 2 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.19, 10.75, 24.74]}
                  rotation={[0, 0, 0]}
                  scale={[1.25, 1.28, 1]}
                />
                <mesh
                  name="Cube 6"
                  geometry={nodes['Cube 6'].geometry}
                  material={materials['Cube 6 Material']}
                  castShadow
                  receiveShadow
                  position={[-71.2, 10.18, 41.03]}
                  rotation={[-3.14, -0.69, -3.13]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 5"
                  geometry={nodes['Cube 5'].geometry}
                  material={materials['Cube 5 Material']}
                  castShadow
                  receiveShadow
                  position={[69.85, 10.13, 38.78]}
                  rotation={[3.14, 0.64, -3.13]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 4"
                  geometry={nodes['Cube 4'].geometry}
                  material={materials['Cube 4 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.19, -56.19, 43.79]}
                  rotation={[2.33, 0, -1.57]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 31"
                  geometry={nodes['Cube 31'].geometry}
                  material={materials['Cube 31 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.33, 77.96, 43.35]}
                  rotation={[0.77, 0, -1.57]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cylinder 2"
                  geometry={nodes['Cylinder 2'].geometry}
                  material={materials['Cylinder 2 Material']}
                  castShadow
                  receiveShadow
                  position={[-1.29, 10.76, 27.16]}
                  rotation={[Math.PI / 2, 0, 0]}
                  scale={[0.81, 0.05, 0.81]}
                />
                <mesh
                  name="Cylinder"
                  geometry={nodes.Cylinder.geometry}
                  material={materials['Cylinder Material']}
                  castShadow
                  receiveShadow
                  position={[-0.32, 11.32, -40.06]}
                  rotation={[Math.PI / 2, -1.56, 0]}
                  scale={[1, 1.39, 1]}
                />
              </group>
              <group name="handle" position={[0, 42.13, -7.71]} rotation={[-Math.PI / 9, 0, 0]}>
                <mesh
                  name="Cylinder1"
                  geometry={nodes.Cylinder1.geometry}
                  material={materials['Cylinder1 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.15, 166.33, 14.93]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[0.36, 10.36, 0.36]}
                />
                <mesh
                  name="Cube 61"
                  geometry={nodes['Cube 61'].geometry}
                  material={materials['Cube 61 Material']}
                  castShadow
                  receiveShadow
                  position={[0.51, -4.75, 15.06]}
                  rotation={[0, 0, Math.PI / 2]}
                  scale={[1, 0.5, 1]}
                />
                <mesh
                  name="Cube 7"
                  geometry={nodes['Cube 7'].geometry}
                  material={materials['Cube 7 Material']}
                  castShadow
                  receiveShadow
                  position={[-50.66, -42.21, 15.06]}
                  rotation={[0, 0, 0]}
                  scale={[1, 0.39, 1]}
                />
                <mesh
                  name="Cube 41"
                  geometry={nodes['Cube 41'].geometry}
                  material={materials['Cube 41 Material']}
                  castShadow
                  receiveShadow
                  position={[50.66, -42.21, 15.06]}
                  rotation={[0, 0, 0]}
                  scale={[1, 0.39, 1]}
                />
              </group>
            </group>
          </group>
          <group name="Group 4" position={[-18.37, 249.26, -161.76]}>
            <spotLight
              name="Spot Light"
              castShadow
              intensity={1.23}
              angle={Math.PI / 5}
              distance={2000}
              shadow-mapSize-width={1024}
              shadow-mapSize-height={1024}
              shadow-camera-fov={119.99999999999999}
              shadow-camera-near={100}
              shadow-camera-far={100000}
              color="#fcfcc3"
              position={[-25.27, -85.56, 7.24]}
              rotation={[0, 0, 0.63]}
            />
            <group name="Light" position={[-21.54, -99.57, -22.36]} rotation={[0.46, 0.71, -0.31]} scale={0.69}>
              <group name="body1" position={[0.22, -22.71, 39.92]} rotation={[0.14, 0, 0]} ref={leftLight}>
                <mesh
                  name="Cube 21"
                  geometry={nodes['Cube 21'].geometry}
                  material={materials['Cube 21 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.19, 10.75, 24.74]}
                  rotation={[0, 0, 0]}
                  scale={[1.25, 1.28, 1]}
                />
                <mesh
                  name="Cube 62"
                  geometry={nodes['Cube 62'].geometry}
                  material={materials['Cube 62 Material']}
                  castShadow
                  receiveShadow
                  position={[-71.2, 10.18, 41.03]}
                  rotation={[-3.14, -0.69, -3.13]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 51"
                  geometry={nodes['Cube 51'].geometry}
                  material={materials['Cube 51 Material']}
                  castShadow
                  receiveShadow
                  position={[69.85, 10.13, 38.78]}
                  rotation={[3.14, 0.64, -3.13]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 42"
                  geometry={nodes['Cube 42'].geometry}
                  material={materials['Cube 42 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.19, -56.19, 43.79]}
                  rotation={[2.33, 0, -1.57]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cube 32"
                  geometry={nodes['Cube 32'].geometry}
                  material={materials['Cube 32 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.33, 77.96, 43.35]}
                  rotation={[0.77, 0, -1.57]}
                  scale={[1.76, 1, 0.31]}
                />
                <mesh
                  name="Cylinder 21"
                  geometry={nodes['Cylinder 21'].geometry}
                  material={materials['Cylinder 21 Material']}
                  castShadow
                  receiveShadow
                  position={[-1.29, 10.76, 27.16]}
                  rotation={[Math.PI / 2, 0, 0]}
                  scale={[0.81, 0.05, 0.81]}
                />
                <mesh
                  name="Cylinder2"
                  geometry={nodes.Cylinder2.geometry}
                  material={materials['Cylinder2 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.32, 11.32, -40.06]}
                  rotation={[Math.PI / 2, -1.56, 0]}
                  scale={[1, 1.39, 1]}
                />
              </group>
              <group name="handle1" position={[0, 64.79, -15.96]} rotation={[-Math.PI / 9, 0, 0]}>
                <mesh
                  name="Cylinder3"
                  geometry={nodes.Cylinder3.geometry}
                  material={materials['Cylinder3 Material']}
                  castShadow
                  receiveShadow
                  position={[-0.15, 178.53, 14.93]}
                  rotation={[0, Math.PI / 2, 0]}
                  scale={[0.36, 11.52, 0.36]}
                />
                <mesh
                  name="Cube 63"
                  geometry={nodes['Cube 63'].geometry}
                  material={materials['Cube 63 Material']}
                  castShadow
                  receiveShadow
                  position={[0.51, -4.75, 15.06]}
                  rotation={[0, 0, Math.PI / 2]}
                  scale={[1, 0.5, 1]}
                />
                <mesh
                  name="Cube 71"
                  geometry={nodes['Cube 71'].geometry}
                  material={materials['Cube 71 Material']}
                  castShadow
                  receiveShadow
                  position={[-50.66, -42.21, 15.06]}
                  rotation={[0, 0, 0]}
                  scale={[1, 0.39, 1]}
                />
                <mesh
                  name="Cube 43"
                  geometry={nodes['Cube 43'].geometry}
                  material={materials['Cube 43 Material']}
                  castShadow
                  receiveShadow
                  position={[50.66, -42.21, 15.06]}
                  rotation={[0, 0, 0]}
                  scale={[1, 0.39, 1]}
                />
              </group>
            </group>
          </group>
          <mesh
            name="Cube 11"
            geometry={nodes['Cube 11'].geometry}
            material={materials['Cube 11 Material']}
            castShadow
            receiveShadow
            position={[3287.61, 103.93, -951.17]}
            scale={[1, 1.94, 9.46]}
          />
          <mesh
            name="Cube2"
            geometry={nodes.Cube2.geometry}
            material={materials['Cube2 Material']}
            castShadow
            receiveShadow
            position={[-1247.77, 103.93, -949.66]}
            scale={[1, 1.94, 9.46]}
          />
          <mesh
            name="Shape"
            geometry={nodes.Shape.geometry}
            material={materials['Shape Material']}
            castShadow
            receiveShadow
            position={[5, 1, 143.25]}
            rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
          />
          <group name="podium" position={[214.05, -181.86, -164.75]} scale={0.74}>
            <mesh
              name="Cube3"
              geometry={nodes.Cube3.geometry}
              material={materials['Cube3 Material']}
              castShadow
              receiveShadow
              position={[0.15, 45.13, 68.42]}
              rotation={[0, 0, 0]}
              scale={[3.19, 0.19, 0.04]}
            />
            <group name="Mic 2" position={[69.94, 78.86, -15.58]} rotation={[0, 0.64, 0]} scale={1}>
              <mesh
                name="Cube 44"
                geometry={nodes['Cube 44'].geometry}
                material={materials['Cube 44 Material']}
                castShadow
                receiveShadow
                position={[7.36, 37.46, 3.47]}
                rotation={[0, 0, 0.68]}
                scale={[0.71, 0.89, 0.4]}
              />
              <mesh
                name="Path2"
                geometry={nodes.Path2.geometry}
                material={materials['Path2 Material']}
                castShadow
                receiveShadow
                position={[-14.6, -53.08, 4.7]}
              />
            </group>
            <group name="Mic" position={[-72.47, 77.52, -26.41]} rotation={[-Math.PI, 0.65, -Math.PI]}>
              <mesh
                name="Cube 45"
                geometry={nodes['Cube 45'].geometry}
                material={materials['Cube 45 Material']}
                castShadow
                receiveShadow
                position={[7.36, 37.46, 3.47]}
                rotation={[0, 0, 0.68]}
                scale={[0.71, 0.89, 0.4]}
              />
              <mesh
                name="Path3"
                geometry={nodes.Path3.geometry}
                material={materials['Path3 Material']}
                castShadow
                receiveShadow
                position={[-14.6, -53.08, 4.7]}
              />
            </group>
            <mesh
              name="Boolean"
              geometry={nodes.Boolean.geometry}
              material={nodes.Boolean.material}
              castShadow
              receiveShadow
              position={[4.17, 62.48, -16.72]}
              scale={[1, 0.63, 1]}
            />
            <mesh
              name="Cube 46"
              geometry={nodes['Cube 46'].geometry}
              material={materials['Cube 46 Material']}
              castShadow
              receiveShadow
              position={[0.23, -164.26, 1.35]}
              scale={[1.66, 0.23, 1.22]}
            />
            <mesh
              name="Cube 33"
              geometry={nodes['Cube 33'].geometry}
              material={materials['Cube 33 Material']}
              castShadow
              receiveShadow
              position={[0.23, -149.54, 1.35]}
              scale={[1.91, 0.26, 1.39]}
            />
            <mesh
              name="Cube 22"
              geometry={nodes['Cube 22'].geometry}
              material={materials['Cube 22 Material']}
              castShadow
              receiveShadow
              position={[0.47, -63.35, 36.05]}
              scale={[1.17, 1, 1]}
            />
          </group>
          <group name="Group 2" position={[1638.43, 106.85, -490.12]} scale={[1, 1.35, 1]} ref={rightCurtainRef}>
            <mesh
              name="Path 4"
              geometry={nodes['Path 4'].geometry}
              material={materials['Path 4 Material']}
              castShadow
              receiveShadow
              position={[24.8, -3.54, 0]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
              scale={[1, 1, 12.11]}
            />
            <mesh
              name="Path 3"
              geometry={nodes['Path 3'].geometry}
              material={materials['Path 3 Material']}
              castShadow
              receiveShadow
              position={[-527.05, -3.54, 0]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
              scale={[-1, 1, 12.11]}
            />
          </group>
          <group name="Group" position={[540.99, 106.85, -490.12]} scale={[1, 1.35, 1]} ref={leftCurtainRef}>
            <mesh
              name="Path 22"
              geometry={nodes['Path 22'].geometry}
              material={materials['Path 22 Material']}
              castShadow
              receiveShadow
              position={[22.99, -3.54, 0]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
              scale={[1, 1, 12.11]}
            />
            <mesh
              name="Path4"
              geometry={nodes.Path4.geometry}
              material={materials['Path4 Material']}
              castShadow
              receiveShadow
              position={[-525.24, -3.54, 0]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
              scale={[-1, 1, 12.11]}
            />
          </group>
          <mesh
            name="Rectangle"
            geometry={nodes.Rectangle.geometry}
            material={materials['Rectangle Material']}
            castShadow
            receiveShadow
            position={[1021.2, 103.8, -1608.95]}
          />
          <directionalLight
            name="Directional Light"
            castShadow
            intensity={0.7}
            shadow-mapSize-width={1024}
            shadow-mapSize-height={1024}
            shadow-camera-near={-10000}
            shadow-camera-far={100000}
            shadow-camera-left={-1000}
            shadow-camera-right={1000}
            shadow-camera-top={1000}
            shadow-camera-bottom={-1000}
            position={[200, 300, 300]}
          />
          <OrthographicCamera ref={cameraRef} name="1" makeDefault={true} far={10000} near={-50000} zoom={1.3} position={[-40, -15, 0]} rotation={[MathUtils.degToRad(-7), 0, 0]}/>
          <hemisphereLight name="Default Ambient Light" intensity={0.005} color="#eaeaea" />
        </scene>
      </group>
    </>
  )
}

